import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SSRProvider } from '@/context/SSRContext'
import './index.css'
import App from './App'

const rootElement = document.getElementById('root')!

const app = (
  <StrictMode>
    <SSRProvider value={false}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SSRProvider>
  </StrictMode>
)

if (rootElement.childElementCount > 0) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
